import React from 'react';

const ServiceItem = ({ service, index }) => {
  const animationType =
    index % 4 === 0
      ? 'fade-up'
      : index % 4 === 1
      ? 'zoom-in-left'
      : index % 4 === 2
      ? 'fade-right'
      : 'zoom-in';

  const bgColor = index % 2 === 0 ? 'bg-white' : 'bg-gray-100';

  return (
    <div id={service.id} className={`w-full py-2 px-4 justify-text ${bgColor}`}>
      <div
        className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-start mb-8 px-2 py-6 md:px-0"
        data-aos={animationType}
      >
        <div
          className={`${index % 2 !== 0 ? 'lg:order-2' : ''}`}
          data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}
          data-aos-delay="100"
        >
          <img
            src={service.image}
            alt={service.title}
            className="rounded-lg shadow-md w-full h-auto object-cover"
          />
        </div>

        <div
          className={`${index % 2 !== 0 ? 'lg:order-1' : ''} text-gray-700 text-sm md:text-base lg:text-md 2xl:text-xl space-y-4`}
          data-aos={index % 2 === 0 ? 'fade-left' : 'fade-right'}
          data-aos-delay="200"
        >
          <div className="flex flex-col items-start space-y-2">
            {service.icon && (
              <img
                src={service.icon}
                alt={`${service.title} icon`}
                className="w-20 h-20 rounded-full"
              />
            )}
            <h2 className="text-xl md:text-2xl font-semibold text-gray-900">
              {service.title}
            </h2>
          </div>

          {service.paragraphs.map((para, idx) => (
            <p key={idx}>{para}</p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceItem;
